import React, { useState, useLayoutEffect } from "react";
import MediaQuery from "react-responsive";

import Text, { TEXT_TYPES } from "../Text";

import { MID_WIDTH_BREAKPOINT } from "../../../lib/constants";

import "./index.css";

const IFRAME_WIDTH = 480;
const IFRAME_HEIGHT = 270;

function Card({ type, videoText, videoUrl }) {
  const [iframeWidth, setIframeWidth] = useState(window.innerWidth - 32);
  useLayoutEffect(() => {
    function updateWidth() {
      setIframeWidth(window.innerWidth - 32);
    }

    window.addEventListener("resize", updateWidth);
  }, [iframeWidth]);

  if (!type) {
    return <div />;
  }

  const isIntro = type === CARD_TYPES.INTRO;
  const isReadScripture = type === CARD_TYPES.READ_SCRIPTURE;

  const readScriptureText = (
    <div className="Card__label">
      <Text type={TEXT_TYPES.HEADER}>{videoText}</Text>
      <div className="Card__label__author__section">
        <Text type={TEXT_TYPES.AUTHOR}>The Bible Project</Text>
      </div>
    </div>
  );

  const introText = (
    <div className="Card__label">
      <Text type={TEXT_TYPES.HEADER}>Reading Plans</Text>
      <div className="Card__label__section">
        <Text>
          This year, West Side and East Side will have their own reading plans.
          Please select your side to view your plan!
        </Text>
      </div>
      <div className="Card__label__section">
        <Text>
          <div>East Side Elders: Sean, Matt, and Kevin Shedden </div>
          <div>West Side Elders: Pira, Rob and Kevin Kim </div>
        </Text>
      </div>
      <div className="Card__label__section">
        <Text>
          If you're not sure what side you are on, please ask your pastor.{" "}
        </Text>
      </div>
    </div>
  );

  //TODO: clean up logic so that card options are easier to select
  return (
    <div className="Card__component">
      {(isReadScripture || isIntro) && (
        <div style={{ overflow: "hidden", position: "relative" }}>
          <MediaQuery maxWidth={MID_WIDTH_BREAKPOINT}>
            <iframe
              width={iframeWidth}
              height={(iframeWidth / IFRAME_WIDTH) * IFRAME_HEIGHT}
              src={videoUrl}
              title={videoText}
            />
          </MediaQuery>
          <MediaQuery minWidth={MID_WIDTH_BREAKPOINT + 1}>
            <iframe
              width={IFRAME_WIDTH}
              height={IFRAME_HEIGHT}
              src={videoUrl}
              title={videoText}
            />
          </MediaQuery>
        </div>
      )}
      {/* {isReflection && (
        <img src={reflectionImg} width="100%" alt="reflection" />
      )}
      {isEndOfMonth && (
        <img src={endOfMonthImg} width="100%" alt="reflection" />
      )} */}
      {/* {isPsalmReflection && (
        <img src={reflectionImg} width="100%" alt="reflection" />
      )} */}
      {isReadScripture && readScriptureText}
      {/* {isEndOfMonth && endOfMonthText} */}
      {/* {isPsalmReflection && psalmReflectionText} */}
      {/* {isReflection && reflectionText} */}
      {isIntro && introText}
    </div>
  );
}

export const CARD_TYPES = {
  END_OF_MONTH: "END_OF_MONTH",
  INTRO: "INTRO",
  READ_SCRIPTURE: "READ_SCRIPTURE",
  REFLECTION: "REFLECTION",
  PSALMREFLECTION: "PSALMREFLECTION",
};

export default Card;
